<template>
  <span
    ref="root"
    class="object-needs-review-icon"
    :class="{ 'object-needs-review-icon--labeled': !!label }"
    data-bs-toggle="tooltip"
    data-bs-placement="top"
    :title="tooltip"
    :role="label ? 'status' : 'img'"
    :aria-label="tooltip"
  >
    <Icon icon="fa-pro-solid:hourglass-half" />
    <span v-if="label" class="object-needs-review-icon__label">{{ label }}</span>
  </span>
</template>

<script>
import { onBeforeUnmount, onMounted, ref } from 'vue'
import { OBJECT_REVIEW_TOOLTIP } from '@/utils/objectReview'

export default {
  name: 'ObjectNeedsReviewIcon',
  props: {
    tooltip: {
      type: String,
      default: OBJECT_REVIEW_TOOLTIP,
    },
    label: {
      type: String,
      default: null,
    },
  },
  setup() {
    const root = ref(null)
    let tooltipInstance = null

    onMounted(() => {
      const TooltipCtor = window?.bootstrap?.Tooltip
      if (TooltipCtor && root.value) {
        tooltipInstance = TooltipCtor.getOrCreateInstance(root.value)
      }
    })

    onBeforeUnmount(() => {
      tooltipInstance?.dispose()
    })

    return { root }
  },
}
</script>

<style scoped lang="scss">
.object-needs-review-icon {
  display: inline-flex;
  align-items: center;
  flex-shrink: 0;
  color: #6b7f90;
  font-size: 1.05rem;
  line-height: 1;
  cursor: help;
}

.object-needs-review-icon--labeled {
  gap: 0.42rem;
  min-height: 2rem;
  padding: 0.34rem 0.72rem;
  border: 1px solid #ffe08a;
  border-radius: 0.25rem;
  color: #664d03;
  background: #fff3cd;
  font-size: 0.9rem;
  font-weight: 750;
  white-space: nowrap;
}

.object-needs-review-icon__label {
  line-height: 1.2;
  white-space: nowrap;
}
</style>
